module.exports = __webpack_public_path__ + "img/twitter.dd1d430c.svg";